/** Small object helpers (ported from the legacy monolith's `src/library/lang/objects.ts`). */

export const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Immutable deep merge: `source` wins, recursing only into plain objects
 * (arrays and scalars are replaced, not concatenated). Used to lay a user's
 * personal permission override over the role bag (UG-5193), mirroring the
 * API's lodash `merge({}, role, user)`.
 */
export const deepMerge = (
  target: Record<string, unknown>,
  source: Record<string, unknown>
): Record<string, unknown> => {
  const result: Record<string, unknown> = { ...target };
  for (const [key, value] of Object.entries(source)) {
    const existing = result[key];
    result[key] = isPlainObject(existing) && isPlainObject(value) ? deepMerge(existing, value) : value;
  }
  return result;
};
